import React from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';

interface SalaryRangeData {
    range: string;
    count: number;
    percentage: number;
}

const salaryRangeData: SalaryRangeData[] = [
    { range: 'Até 3k', count: 32, percentage: 15.0 },
    { range: '3k-5k', count: 48, percentage: 22.5 },
    { range: '5k-8k', count: 67, percentage: 31.5 },
    { range: '8k-12k', count: 43, percentage: 20.2 },
    { range: '12k+', count: 23, percentage: 10.8 },
];

const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-medium text-gray-900">R$ {data.range}</p>
                <p className="text-sm text-gray-600">
                    {data.count} colaboradores ({data.percentage}%)
                </p>
            </div>
        );
    }
    return null;
};

export default function SalaryRangeDistribution() {
    const totalCollaborators = salaryRangeData.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Faixa de Salário
                </h3>
                <p className="text-xs text-gray-600">
                    Distribuição salarial dos {totalCollaborators} colaboradores
                </p>
            </div>

            {/* Chart */}
            <div className="h-48">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={salaryRangeData} margin={{ top: 10, right: 10, left: 10, bottom: 20 }}>
                        <XAxis
                            dataKey="range"
                            tick={{ fontSize: 11 }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis hide />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar
                            dataKey="count"
                            fill="#10B981"
                            radius={[4, 4, 0, 0]}
                            stroke="#ffffff"
                            strokeWidth={1}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">
                        R$ {Math.round(salaryRangeData.reduce((sum, item, index) => {
                            const midPoint = index === 0 ? 2000 : index === 1 ? 4000 : index === 2 ? 6500 : index === 3 ? 10000 : 15000;
                            return sum + (midPoint * item.count);
                        }, 0) / totalCollaborators).toLocaleString()}
                    </div>
                    <div className="text-xs text-gray-500">Salário Médio</div>
                </div>
                <div className="text-center">
                    <div className="text-lg font-bold text-gray-900">
                        R$ {salaryRangeData.find(item => item.count === Math.max(...salaryRangeData.map(d => d.count)))?.range}
                    </div>
                    <div className="text-xs text-gray-500">Faixa Predominante</div>
                </div>
            </div>
        </div>
    );
} 